import styled from '../../config/theme'

const Container = styled.div`
  
`

const Header = styled.div`
  > button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 5px;
  }
`

const Content = styled.div`
  border: 1px solid ${props => props.theme.color.lightGray};
  padding: 10px;
`

export {
  Container,
  Header,
  Content,
}
